import React, { useState } from "react";
import { Formik } from "formik";
import * as Yup from "yup";
import Edit from "../../../../assets/images/editinput.svg";
import "../../../../styles/userManagement.css";
import PropTypes from "prop-types"
import {Select} from "@appkit4/react-components/select"

export default function EditVendor(prop) {
  const [loading, setLoading] = useState(false);
  let {
    VendorBusinessUnitList,
    VendorSubBusinessUnitList,
    updateVendorId,
    handleBack,
    updateVendorDetailsById,
  } = prop;
  const handleSubmit = async (values, { resetForm }) => {
    setLoading(true);
    let editVendorData = {
      vendor_id: updateVendorId?.vendor_id,
      vendor_user_id: updateVendorId?.vendor_user_id,
      vendor_name: values.vendorname,
      contact_name: values.Vendorcontact,
      phone_number: values.PhoneNumber,
      email: values.Email,
      reviewer: values.VendorReviewer,
      reviewer_email: values.VendorEmail,
      vendor_businessunit_id: values.businessUnit,
      vendor_subbusinessunit_id: values.subBusinessUnit,
      vendor_assessment_request_id: updateVendorId?.vendor_assessment_request_id,
      assessment:values.assessment
    };
    updateVendorDetailsById(editVendorData);
    resetForm();
    handleBack();
  };
  let validationSchema = Yup.object().shape({
    vendorname: Yup.string().required("Third Party Name is Required")
    .matches(
      /^[a-zA-Z\d\-_.,&#()\s]+$/,
      "Only alphabets, numbers and some special characters are allowed for this field "
    ),
    Vendorcontact: Yup.string().required("Third Party Contact is Required")
    .matches(
      /^[a-zA-Z\d\-_.,&#()\s]+$/,
      "Only alphabets, numbers and some special characters are allowed for this field "
    ),
    Email: Yup.string().email().required("Email Id is Required"),
    VendorReviewer: Yup.string()
    .matches(
      /^[a-zA-Z\d\-_.,&#()\s]+$/,
      "Only alphabets, numbers and some special characters are allowed for this field "
    ),
    VendorEmail: Yup.string().email(),
    businessUnit: Yup.string().required("Please select Business Unit")
    .matches(
      /^[a-zA-Z\d\-_.,&#()\s]+$/,
      "Only alphabets, numbers and some special characters are allowed for this field "
    ),
    subBusinessUnit: Yup.string().required("Please select Sub Business Unit")
    .matches(
      /^[a-zA-Z\d\-_.,&#()\s]+$/,
      "Only alphabets, numbers and some special characters are allowed for this field "
    ),
  });
  let initialValues = {
    vendorname:
      updateVendorId ? updateVendorId.vendor_name : "",
    Vendorcontact:
      updateVendorId ? updateVendorId.contact_name : "",
    PhoneNumber:
      updateVendorId ? updateVendorId.phone_number : "",
    Email: updateVendorId ? updateVendorId.email : "",
    VendorReviewer:
      updateVendorId ? updateVendorId.reviewer : "",
    VendorEmail:
      updateVendorId ? updateVendorId.reviewer_email : "",
    businessUnit:
      updateVendorId
        ? updateVendorId.vendor_businessunit_id
        : "",
    subBusinessUnit:
      updateVendorId
        ? updateVendorId.vendor_subbusinessunit_id
        : "",
      assessment:updateVendorId
      ? updateVendorId.assessment
      : "",
  };

  var assessmentOption = [
    {
    "id": "1",
    "name": "Yes"},
{
    "id": "0",
    "name": "No"}
];
  return (
    <div>
      <div className="row text-end pt-3">
        <div className="col-md-12">
          <span className="cv-input-label mr-4"></span>
          <span className="cv-input-label mr-3"></span>
          <span
            className="Appkit4-icon icon-arrow-left-outline pointer back-fill"
            onClick={prop.handleBack}
          ></span>
        </div>
      </div>
      <Formik
        onSubmit={handleSubmit}
        initialValues={initialValues}
        enableReinitialize={true}
        validationSchema={validationSchema}
      >
        {(props) => {
          const {
            values,
            touched,
            errors,
            isSubmitting,
            handleChange,
            handleBlur,
            handleSubmit
          } = props;
          return (
            <div className="create-vendor-form-container">
              {loading ? (
                <div className="a-loading a-primary a-m-10 a-loading-24 spinner-alignment"></div>
              ) : (
                <form onSubmit={handleSubmit}>
                  <div className="row">
                    <div className="col-sm-6">
                      <div className="cv-input-field-container">
                        <label htmlFor="ThirdPartyNameEditVendor" className="cv-input-label">
                          Third Party Name <span className="asterisk-required">*</span>
                        </label>
                        <input
                          className="cv-input-field"
                          onBlur={handleBlur}
                          id="ThirdPartyNameEditVendor"
                          type="text"
                          value={values.vendorname}
                          onChange={handleChange("vendorname")}
                          name="vendorname"
                          disabled
                        />
                        <img alt="edit" src={Edit} className="edit-input" />
                      </div>
                      {errors.vendorname && touched.vendorname && (
                        <div className="form-label error">
                          {errors.vendorname}
                        </div>
                      )}
                    </div>
                    <div className="col-sm-6">
                      <div className="cv-input-field-container">
                        <label htmlFor="ThirdPartyContactEditVendor" className="cv-input-label">
                          Third Party Contact <span className="asterisk-required">*</span>
                        </label>
                        <input
                          className="cv-input-field"
                          onBlur={handleBlur}
                          id="ThirdPartyContactEditVendor"
                          type="text"
                          value={values.Vendorcontact}
                          onChange={handleChange("Vendorcontact")}
                          name="Vendorcontact"
                          disabled
                        />
                        <img alt="edit" src={Edit} className="edit-input" />
                      </div>
                      {errors.Vendorcontact && touched.Vendorcontact && (
                        <div className="form-label error">
                          {errors.Vendorcontact}
                        </div>
                      )}
                    </div>
                  </div>
                  <div className="row">
                    <div className="col-sm-6">
                      <div className="cv-input-field-container">
                        <label htmlFor="ThirdPartyEmailEditVendor" className="cv-input-label">
                          Third Party Email <span className="asterisk-required">*</span>
                        </label>
                        <input
                          className="cv-input-field"
                          onBlur={handleBlur}
                          id="ThirdPartyEmailEditVendor"
                          type="email"
                          value={values.Email}
                          onChange={handleChange("Email")}
                          name="Email"
                          disabled
                        />
                        <img alt="edit" src={Edit} className="edit-input" />
                      </div>
                      {errors.Email && touched.Email && (
                        <div className="form-label error">{errors.Email}</div>
                      )}
                    </div>
                    <div className="col-sm-6">
                      <div className="cv-input-field-container">
                        <label htmlFor="PhoneNumberEditVendor" className="cv-input-label">
                          Phone Number <span className="asterisk-required">*</span>
                        </label>
                        <input
                          className="cv-input-field"
                          onBlur={handleBlur}
                          id="PhoneNumberEditVendor"
                          type="tel"
                          value={values.PhoneNumber}
                          onChange={handleChange("PhoneNumber")}
                          name="PhoneNumber"
                        />
                        <img alt="edit" src={Edit} className="edit-input" />
                      </div>
                      {errors.PhoneNumber && touched.PhoneNumber && (
                        <div className="form-label error">
                          {errors.PhoneNumber}
                        </div>
                      )}
                    </div>
                  </div>
                  <div className="row">
                    <div className="col-sm-6">
                      <div className="cv-input-field-container">
                        <label className="cv-input-label">
                          Business Unit <span className="asterisk-required">*</span>
                        </label>
                        <select
                          className="cv-input-field-dropdown"
                          type="text"
                          value={values.businessUnit}
                          onChange={handleChange("businessUnit")}
                          name="businessUnit"
                        >
                          <option key="0">Select Business Unit</option>
                          {VendorBusinessUnitList?.map((each, index) => {
                              return (
                                <option
                                  key={index}
                                  value={each.vendor_department_id}
                                >
                                  {each.vendor_department_name}
                                </option>
                              );
                            })}
                        </select>
                      </div>
                      {errors.businessUnit && touched.businessUnit && (
                        <div className="form-label error">
                          {errors.businessUnit}
                        </div>
                      )}
                    </div>
                    <div className="col-sm-6">
                      <div className="cv-input-field-container">
                        <label className="cv-input-label">
                          Sub Business Unit <span className="asterisk-required">*</span>
                        </label>
                        <select
                          className="cv-input-field-dropdown"
                          type="text"
                          value={values.subBusinessUnit}
                          onChange={handleChange("subBusinessUnit")}
                          name="subBusinessUnit"
                        >
                          <option key="0">Select Sub-Business Unit</option>
                          {VendorSubBusinessUnitList?.map((each, index) => {
                              return (
                                <option
                                  key={index}
                                  value={each.vendor_subdepartent_id}
                                >
                                  {each.vendor_subdepartment_name}
                                </option>
                              );
                            })}
                        </select>
                      </div>
                      {errors.subBusinessUnit && touched.subBusinessUnit && (
                        <div className="form-label error">
                          {errors.subBusinessUnit}
                        </div>
                      )}
                    </div>
                  </div>
                  <div className="row">
                    <div className="col-sm-6">
                      <div className="cv-input-field-container">
                        <label htmlFor="ReviewerEditVendor" className="cv-input-label">
                          Reviewer
                        </label>
                        <input
                          className="cv-input-field"
                          onBlur={handleBlur}
                          id="ReviewerEditVendor"
                          type="text"
                          value={values.VendorReviewer}
                          onChange={handleChange("VendorReviewer")}
                          name="Vendor_Reviewer"
                        />
                        <img alt="edit" src={Edit} className="edit-input" />
                      </div>
                    </div>
                    <div className="col-sm-6">
                      <div className="cv-input-field-container">
                        <label htmlFor="ReviewerEmailEditVendor" className="cv-input-label">
                          Reviewer Email
                        </label>
                        <input
                          className="cv-input-field"
                          type="email"
                          id="ReviewerEmailEditVendor"
                          onBlur={handleBlur}
                          value={values.VendorEmail}
                          onChange={handleChange("VendorEmail")}
                          name="Vendor_Email"
                        />
                        <img alt="edit" src={Edit} className="edit-input" />
                      </div>
                    </div>
                  </div>
                  <div className="row">
                  <div className="col-sm-6">
                    <div className="cv-input-field-container">
                      <label className="cv-input-label">
                      Assessment Response <span className="asterisk-required">*</span>
                      </label>
                      <select
                          className="cv-input-field-dropdown"
                          type="text"
                          value={values.assessment}
                          onChange={handleChange("assessment")}
                          name="assessment"
                        >
                          <option key="0">Select option</option>
                          {assessmentOption?.map((each, index) => {
                              return (
                                <option
                                  key={index}
                                  value={each.id}
                                >
                                  {each.name}
                                </option>
                              );
                            })}
                        </select>
                    </div>
                    {errors.assessment && touched.assessment && (
                      <div className="form-label error">{errors.assessment}</div>
                    )}
                  </div>
                  </div> 
                  <div className="options-container">
                    <button
                      className="cancel-button"
                      type="reset"
                      onClick={prop.handleBack}
                    >
                      Cancel
                    </button>
                    <button
                      type="submit"
                      disabled={isSubmitting}
                      className="save-button m-l-2"
                    >
                      Update
                    </button>
                  </div>
                </form>
              )}
            </div>
          );
        }}
      </Formik>
    </div>
  );
}

EditVendor.propTypes = {
  values: PropTypes.any,
  touched: PropTypes.any,
  errors: PropTypes.any,
  isSubmitting: PropTypes.any,
  handleChange: PropTypes.any,
  handleBlur: PropTypes.any,
  handleSubmit: PropTypes.any,
}
